/**
 * Phone-number normalizing, in one place. Everything that reads a US number a
 * person typed or pasted goes through these: "+1 (207) 555-0142", "207-555-0142"
 * and "2075550142" all mean the same ten digits, which is also the bare form
 * the contacts index stores.
 */

export function digitsOnly(text: string): string {
  return text.replace(/\D/g, ``)
}

/** The digits of a typed number, with the country code dropped from an eleven-digit US number. */
export function phoneDigits(text: string): string {
  const digits = digitsOnly(text)
  if (digits.length === 11 && digits.startsWith(`1`)) return digits.slice(1)
  return digits
}

/** The ten digits of a complete US number, or undefined for anything partial or over-long. */
export function usPhoneNumber(text: string): string | undefined {
  const digits = phoneDigits(text)
  return digits.length === 10 ? digits : undefined
}
